import { render, staticRenderFns } from "./ExpandableAbstract.vue?vue&type=template&id=1cdc865d&"
import script from "./ExpandableAbstract.vue?vue&type=script&lang=js&"
export * from "./ExpandableAbstract.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableAbstract.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
